import { endPoint, endPointAccount } from './base.config';

export const users = {
  checkPassword: `${endPoint}users/check-password`,
  getRoleActions: `${endPointAccount}/action/bilagsky`,
  getLoginUserData: `${endPoint}users/:id/login-user-data`,
};
